export default "__VITE_ASSET__3b83ffe1__"